<template>
  <nav aria-label="Page navigation">
    <ul class="pagination justify-content-end pagination-primary">
      <!-- Mostrar 3 índices de página antes del índice actual -->
      <li v-if="currentPage > 3" class="page-item">
        <a class="page-link" href="#" @click="changePage(currentPage - 3)">{{
          currentPage - 3
        }}</a>
      </li>
      <li v-if="currentPage > 2" class="page-item">
        <a class="page-link" href="#" @click="changePage(currentPage - 2)">{{
          currentPage - 2
        }}</a>
      </li>
      <li v-if="currentPage > 1" class="page-item">
        <a class="page-link" href="#" @click="changePage(currentPage - 1)">{{
          currentPage - 1
        }}</a>
      </li>

      <!-- Mostrar el índice actual -->
      <li class="page-item active">
        <a class="page-link" href="#">{{ currentPage }}</a>
      </li>

      <!-- Mostrar 3 índices de página después del índice actual -->
      <li v-if="currentPage < lastPage" class="page-item">
        <a class="page-link" href="#" @click="changePage(currentPage + 1)">{{
          currentPage + 1
        }}</a>
      </li>
      <li v-if="currentPage + 1 < lastPage" class="page-item">
        <a class="page-link" href="#" @click="changePage(currentPage + 2)">{{
          currentPage + 2
        }}</a>
      </li>
      <li v-if="currentPage + 2 < lastPage" class="page-item">
        <a class="page-link" href="#" @click="changePage(currentPage + 3)">{{
          currentPage + 3
        }}</a>
      </li>

      <!-- Mostrar el último índice si excede 3 posiciones -->
      <li v-if="currentPage + 3 < lastPage" class="page-item">
        <a class="page-link" href="#" @click="changePage(lastPage)">{{
          lastPage
        }}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    lastPage: {
      type: Number,
      required: true,
    },
  },
  methods: {
    changePage(page) {
      this.$emit("page-change", page);
    },
  },
};
</script>

<style></style>
